import { Stack } from "@mui/material";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import theme from "./theme/theme";

import {
  AuthWrapper,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  login,
} from "./auth/auth";
import Layout from "./layout/layout";
import GlobalStyle from "./theme/global-style";
import { LoadingProvider } from "./hooks/loadingcontext";

const Login = () => {
  login();
  return <Stack></Stack>;
};

const App = () => {
  return (
    <React.Suspense fallback={<div>loading...</div>}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <GlobalStyle />
            <BrowserRouter>
              <AuthWrapper>
                <AuthenticatedTemplate>
                  <LoadingProvider>
                    <Layout />
                  </LoadingProvider>
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                  <Login />
                </UnauthenticatedTemplate>
              </AuthWrapper>
            </BrowserRouter>
          </ThemeProvider>
        </StyledEngineProvider>
      </LocalizationProvider>
    </React.Suspense>
  );
};
export default App;
